$(document).ready(function() {
    var target = document.querySelector('.w3-product-options');
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation){
        //console.log("asd "+mutation.type);
        $('button#btn-micas').attr('disabled' , false);
        $('button#btn-blupers').attr('disabled' , false);
        $("button#btn-micas").removeClass('disabled');
        $("button#btn-blupers").removeClass('disabled');
        $('.load-btn-micas').hide();
      });
    });
  var config = { childList: true, subtree: true }
  observer.observe(target, config);
});